import { render, staticRenderFns } from "./mRulesPage.vue?vue&type=template&id=88926f7a&scoped=true"
import script from "./mRulesPage.vue?vue&type=script&lang=js"
export * from "./mRulesPage.vue?vue&type=script&lang=js"
import style0 from "./mRulesPage.vue?vue&type=style&index=0&id=88926f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88926f7a",
  null
  
)

export default component.exports